import AppBackButton from "../../../components/global/GoBack/AppBackButton";
import Settlement from "../../../components/modules/settlement/Settlement";

export default () => {
  return (
    <>
      <AppBackButton containerClassName="flex w-full justify-start px-6 pt-6" />
      <Settlement />
    </>
  );
};
